import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';

import App from '../hub/App.vue';
import router from '../hub/router';
import i18nMessages from '../hub/i18n';
import '../hub/assets/styles.css';

// Inject the installation brand color so CSS components (.btn-primary,
// .input focus ring) follow whatever the customer configured in GlobalConfig.
const brandColor = window.globalConfig?.BRAND_PRIMARY_COLOR;
if (brandColor) {
  document.documentElement.style.setProperty('--brand', brandColor);
}

const app = createApp(App);

const i18n = createI18n({
  legacy: false,
  locale: 'pt_BR',
  fallbackLocale: 'en',
  messages: i18nMessages,
});

app.use(createPinia());
app.use(router);
app.use(i18n);

window.onload = () => {
  app.mount('#app');
};
